import { useQueryClient } from '@tanstack/react-query'
import { getAllExternalIdsByProjectAndVersion } from 'api/estructuraCostes/boqJitApi'
import { NavPresupuestoContext } from 'context'
import { ViewerContext } from 'context/ViewerContext'
import { useContext } from 'react'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { getCurrentModelVersion, viewer } from 'utils/launchViewer'
import { useGetDataBoq } from './useGetDataBoq'

const numerosUnicos = (arr1, arr2) => {
  // Filtrar los números que están en arr1 pero no en arr2
  const unicosEnArr1 = arr1.filter(num => !arr2.includes(num))

  // Filtrar los números que están en arr2 pero no en arr1
  const unicosEnArr2 = arr2.filter(num => !arr1.includes(num))

  // Concatenar ambos resultados para obtener los números únicos en ambos arrays
  return unicosEnArr1.concat(unicosEnArr2)
}

export const useFilterElementsInModel = () => {
  const { resetModulesFilter, setCurrentLevel, modulesFilter } = useContext(
    NavPresupuestoContext
  )
  const { getAllDbIdsByTipo } = useGetDataBoq()

  const queryClient = useQueryClient()
  const { idProject } = useParams()
  const { externalIdsMapping } = useContext(ViewerContext)

  const handleReset = async () => {
    if (modulesFilter.length === 0) {
      viewer.clearThemingColors()
      return
    }
    resetModulesFilter()
    setCurrentLevel(null)
    viewer.clearThemingColors()
  }

  const getMeasuredElements = async () => {
    // * Sacar los elementos medidos por idProject y version
    const version = getCurrentModelVersion()

    const { data, length } = await queryClient.fetchQuery({
      queryKey: ['externalids-medidos', idProject, version],
      queryFn: () => getAllExternalIdsByProjectAndVersion(idProject, version),
    })

    return { data, length }
  }

  const showMeasuredElements = async (
    showToast = false,
    filterViewer = false
  ) => {
    await handleReset()

    const { data, length } = await getMeasuredElements()

    if (length === 0) return toast.success('0 elementos medidos')
    const dbIds = data.map(externalId => externalIdsMapping[externalId])
    filterViewer && viewer.isolate(dbIds)
    showToast && toast.success(`${length} elementos medidos`)
    return length
  }

  const showNoMeasuredElements = async (
    showToast = false,
    filterViewer = false
  ) => {
    await handleReset()

    const valuesWithBimlinks = await getAllDbIdsByTipo()

    const { data } = await getMeasuredElements()

    const dbIds = data.map(externalId => externalIdsMapping[externalId])

    const resultado = numerosUnicos(valuesWithBimlinks, dbIds)
    if (resultado.length === 0)
      return toast.success('Todos los elementos han sido medidos')
    filterViewer && viewer.isolate(resultado)
    showToast && toast.success(`${resultado.length} elementos sin medir`)
    return resultado.length
  }

  return {
    showMeasuredElements,
    showNoMeasuredElements,
    handleReset,
  }
}
